import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);

const EPAY_SERVER = ConfigurationService.get(ConfigurationKeys.EPAY_SERVER);
const EPAY_TENANT = ConfigurationService.get(ConfigurationKeys.EPAY_TENANT);
const EPAY_API = `${EPAY_SERVER}/rest/v1/checkout/${EPAY_TENANT}`;

// pick live endpoint for easier development, as local server doesn't have many users
export const FANCLUB_STATUS =
  `${BASE_URL}/rest/v1.0/profile/{username}/fanclub`;

export const FAN_CLUB_PRODUCT_URL =
  // eslint-disable-next-line max-len
  `${EPAY_API}/en/FANCLUB?userName={username}&accessHash={accessHash}&target={performer}&amount={amount}`;

export const FAVOURITES_BASE = (username, performerName) =>
  `${BASE_URL}/rest/v1.0/favorites/${encodeURIComponent(username)}/${encodeURIComponent(performerName)}`;

export const FAVOURITES_COUNT = (performerName) =>
  `${BASE_URL}/rest/v1.0/favorites/${encodeURIComponent(performerName)}/count`;

export const FRIENDS_STATUS_URL =
  `${BASE_URL}/rest/v1.0/friends/{username}/{friendUsername}`;

export const GET_BROADCAST_SOURCE_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/streamInfo`;

export const GET_FANCLUB_AUTHORIZATION_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/fanclub/authorization`;

export const GET_FANCLUB_INFO_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/fanclub`;

export const GET_PERFORMER_DETAILED_INFO_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/info`;

export const GET_PERFORMER_GALLERIES_URL =
  `${BASE_URL}/rest/v1.0/users/{username}/galleries`;

export const GET_PERFORMER_GALLERY_IMAGES_URL =
  `${GET_PERFORMER_GALLERIES_URL}/{galleryId}/images`;

export const GET_PERFORMER_GIFTS_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/gifts`;

export const GET_PERFORMER_INFO_URL =
  `${BASE_URL}/rest/v1.0/search/performer/{username}`;

export const GET_PERFORMER_VIDEOS_URL =
  `${BASE_URL}/rest/v1.0/marketplace/purchases/videos?performer={username}`;

export const GET_PERFORMER_WISHLIST_URL =
  `${BASE_URL}/rest/v1.0/wishList/{username}`;

export const GET_SERVER_TIME_URL =
  `${WEBCHAT_HOST}webServerTimestamp`;

export const PAY_SUBSCRIPTION_URL =
  `${EPAY_API}/en/{username}/{productId}/{processorId}`;

export const PRIVATE_SHOW_ACTION_URL =
  `${WEBCHAT_HOST}privateShowAction?userName={username}`;
